import { ApiType } from "@gymflow/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { apiV2 } from "../../apiV2";
import { memberQueryKeys } from "./memberQueryKeys";

export function useMutationMembershipLinkMember({ api }: { api: ApiType }) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({
      primarySubscriptionId,
      secondaryMemberId,
    }: {
      primarySubscriptionId: number;
      secondaryMemberId: string;
    }) => {
      await api.memberApi.membershipLinkMember(
        primarySubscriptionId,
        secondaryMemberId,
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: memberQueryKeys.all() });
      queryClient.invalidateQueries({
        queryKey: apiV2.staff.subscription.keys.all(),
      });
    },
  });
}
